// extracted by extract-css-chunks-webpack-plugin
module.exports = {"categoryDescription":"categoryDescription_Fpd9L mb-7.5 w-full","content":"content_deo8e text-[1.2em] leading-[1.6] text-black-light sm_text-[1.2em]"};